module.exports = __webpack_public_path__ + "media/images/icons/192x192-5a70c9a58e814459619caf817acd81e9.png";